export type InternalRequestInit = {
  withAuth?: boolean;
  withGuestId?: boolean | string;
  withSession?: boolean;
  withIfMatch?: string;
  locale?: string;
  json?: Record<string, unknown>;
  headers?: Headers;
  signal?: AbortSignal;
  withDeduplicationId?: string;
} & RequestInit;

export type GlueRequestInitExtension = {
  glue?: {
    type: string;
  };
};

export type HttpClientPlugin<T = InternalRequestInit> = Partial<{
  beforeRequest(url: string, options: T): Promise<{ url: string; options: T }>;
}>;

export type HttpClient<Init = InternalRequestInit> = {
  get(url: string, options?: Init): Promise<Response>;
  post(url: string, options?: Init): Promise<Response>;
  patch(url: string, options?: Init): Promise<Response>;
  delete(url: string, options?: Init): Promise<Response>;
  handleResponse<T>(res: Response): Promise<T | never>;
};

export type HttpClientOptions = {
  plugins?: Array<HttpClientPlugin>;
};

export type ServerActionError<E> = {
  ok: false;
  data: null;
  error: E;
};
export type ServerActionSuccess<T> = {
  ok: true;
  data: T;
  error: null;
};

export type ServerActionResult<T, E> = ServerActionSuccess<T> | ServerActionError<E>;

export enum RevalidateTags {
  CARTS = 'carts',
  CART = 'cart',
  PRODUCTS = 'products',
  PRODUCT = 'product',
  CUSTOMER = 'customer',
  USER = 'user',
  STORE = 'store',
  URL_RESOLVER = 'url-resolver',
  CATEGORY_TREES = 'category-trees',
  NAVIGATION = 'navigation',
  ENTITY = 'entity',
  CATALOG_SEARCH = 'catalog-search',
  CONTENT = 'content',
  YOUR_PRICE = 'your-price',
  ORDER_HISTORY = 'order-history',
}

export enum HTTP_STATUS {
  NOT_FOUND = 404,
}
